import React, { Component } from 'react';

class FaqQuestion extends Component {
  state = {
    isOpen: false
  }

  toggleOpenQuestion = () => {
    const { isOpen } = this.state;
    this.setState({isOpen: !isOpen})
  }

  render(){
    const { question, answer } = this.props.question
    const { isOpen } = this.state
    return (
      <div className="faqQuestion-container">
        <div className="faqQuestion-header" onClick={this.toggleOpenQuestion}>
          <p className="faqQuestion-header-text">{question}</p>
          <div
            className={`faqQuestion-icon-container ${
              isOpen ? "isOpen" : "isClosed"
            }`}
          >
            <div
              className={`faqQuestion-icon ${isOpen ? "isOpen" : "isClosed"}`} />
            <div
              className={`faqQuestion-icon vertical ${
                isOpen ? "isOpen" : "isClosed"
                }`} />
          </div>
        </div>
        <p className={`faqQuestion-answer ${isOpen ? "isOpen" : "isClosed"}`}>
          {answer}
        </p>
      </div>
    );
  }
}

export default FaqQuestion;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/PackSelectorPage/FAQ/question.js